import React, { Component } from 'react';
import { connect } from 'react-redux';

import { SendMessageForm } from './elements';

import networkingActions from '../../../../../actions/networking/networking';

class SendMessage extends Component {

    postMessage( message ) {

        const { sendMessage } = this.props, personId = localStorage.getItem('person_id');

        sendMessage( message, personId );
    };

    render() {
        return (
            <div>
                <div className="col-sm-12">
                    <h1 className="h1">Start your conversation</h1>
                    <h5 className="h5">To start a new conversation with the recipient, send them a message</h5>
                </div>
                <SendMessageForm onSubmit={ ( message ) => this.postMessage( message ) } />
            </div>
        );
    };
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        sendMessage: ( conversationId, personId ) => dispatch( networkingActions.sendMessage( conversationId, personId ) ),
    };
};

export default connect( null, mapDispatchToProps )( SendMessage );



// WEBPACK FOOTER //
// src/client/components/site/features/networking/pages/SendMessage.js